import { React, useEffect, useState } from 'react';
import { Stack, Form, Spinner, Accordion, Button, Row, Col, Container } from 'react-bootstrap';
import * as api from 'services/api';
import _ from 'lodash';
import './PseudoCodeList.css';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { FaArrowUp } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { PaginatedAccordion } from './PaginatedAccordion';
export function PseudoCodeList({ pseudoCode, setPseudo, overrideCode, setOverride, showModal }) {
    const { t } = useTranslation();
    const { controlCentre } = useControlCentreContext();
    //#region -------------------- STATES -----------------
    const [pseudocodes, setPseudocodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [loadedItems, setLoadedItems] = useState(10);
    const [disabledSelect, setDisabledSelect] = useState(true);
    const [hideSelectOrigin, setHideSelectOrigin] = useState(false);
    //#endregion

    //#region ----------------------- EFFECTS -------------

    useEffect(() => {
        if (controlCentre.origin) {
            setPseudo({
                controlCentreText: controlCentre.centrename,
                pseudoCodeId: controlCentre.origin.pseudoCodeId,
                pseudoCode: controlCentre.origin.pseudoCode,
                pseudoCodeText: controlCentre.origin.pseudoCodeText,
                pseudoCodeDescription: controlCentre.origin.pseudoCodeDescription
            })
            setHideSelectOrigin(true);
        }
    }, [controlCentre])

    const fetchPseudoCodes = async () => {

        try {
            const response = await api.getPseudoCodes();
            if (response.data === null || response.status !== 200) {
                setError(t('ccErrorFetchingPseudocode'));
            } else {
                setPseudocodes(response.data);
            }
        } catch (error) {
            console.error('Error fetching pseudo codes:', error);
            setError(t('ccErrorFetchingPseudocode'));
        }
    }

    useEffect(() => {
        fetchPseudoCodes();
    }, [])

    useEffect(() => {
        if ((pseudoCode.pseudoCodeId !== '') && (overrideCode.pseudoCodeId !== '')) {
            setDisabledSelect(false);
        }else{
            setDisabledSelect(true);
        }
    }, [pseudoCode, overrideCode])
    //#endregion

    //#region --------------------- HANDLERS --------------

    const handleSearch = _.debounce(async (event) => {

        const searchParam = event.target.value;

        if(searchParam.trim() !== ''){
            setLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 500));

            try {
                const response = await api.getPseudoCodes(searchParam);
    
                setLoading(false);
    
                if (response.data === null || response.status !== 200) {
                    setError(t('ccErrorFetchingPseudocode'));
                } else {
                    setPseudocodes(response.data);
                    const countItems = response.data.length
                    setLoadedItems(countItems);
                }
            } catch (error) {
                console.error('Error fetching pseudo codes:', error);
                setError(t('ccErrorFetchingPseudocode'));
            } finally {
                setLoading(false);
            }
    
        }else{
            fetchPseudoCodes();
        }


    }, 1000);

    const handleSetOrigin = (origin) => {
        if (origin.pseudoCodeId !== overrideCode.pseudoCodeId) {
            const cloneorigin = origin;
            setPseudo(cloneorigin);
        }
    };

    const handleSetDestination = (destination) => {
        if (destination.pseudoCodeId !== pseudoCode.pseudoCodeId) {
            const clonedest = destination;
            setOverride(clonedest);
        }
    };
    const handleClean = (e) => {
        setDisabledSelect(true);
        if (e === 1) setPseudo({ ...pseudoCode, pseudoCodeId: '' })
        else setOverride({ ...overrideCode, pseudoCodeId: '' })
    }
    const handleShowModal = (show) => {
        showModal(show);
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    //#endregion

    return (
        <div>
            <div>
                <Form>
                    <Stack direction="horizontal" gap="8" className="mt-3 justify-content-between">
                        <div className="PseudocodeList__searcherContainer">
                            <Form.Control
                                type="text"
                                placeholder={t('ccSearchPseudocode')}
                                className="PseudocodeList__searcher bg-light"
                                onChange={handleSearch}
                            />
                            {loading && (
                                <Spinner animation="border" variant="secondary" size="sm" className="PseudocodeList__spinner" />
                            )}
                        </div>
                    </Stack>
                    <Stack direction="horizontal" className="justify-content-start">
                        {error && <p className="text-danger fw-semibold">{error}</p>}
                    </Stack>
                </Form>
                <Container className='mt-2 mb-3'>
                    <Row>
                        <Col>
                            {pseudoCode.pseudoCodeId !== '' && (
                                <div className='rounded border border-solid border-dark p-3'>
                                    <Stack direction="horizontal" gap={3} className="justify-content-between">
                                        <p style={{ color: 'grey' }}>{t('ccPseudoCodeOrigin')}</p>
                                        <Button variant="light" className='me-2' onClick={() => handleClean(1)}>x</Button>
                                    </Stack>
                                    <div className='px-2'>
                                        <p className='mb-0'><strong>{t('ccPseudoCodeID')} :</strong> {pseudoCode.pseudoCodeId}</p>
                                        <p className='mb-0'><strong>{t('ccPseudoCode')} :</strong> {pseudoCode.pseudoCode}</p>
                                        <p className='mb-0'><strong>{t('ccPseudoCodeText')} :</strong> {pseudoCode.pseudoCodeText}</p>
                                    </div>
                                </div>
                            )}
                        </Col>
                        <Col>
                            {overrideCode.pseudoCodeId !== '' && (
                                <div className='rounded border border-solid border-danger p-3'>
                                    <Stack direction="horizontal" gap={3} className="justify-content-between">
                                        <p style={{ color: 'grey' }}>{t('ccPseudoCodeDestination')}</p>
                                        <Button variant="light" className='me-2' onClick={() => handleClean(2)}>x</Button>
                                    </Stack>
                                    <div className='px-2'>
                                        <p className='mb-0'><strong>{t('ccOverrideID')} :</strong> {overrideCode.pseudoCodeId}</p>
                                        <p className='mb-0'><strong>{t('ccOverride')} :</strong> {overrideCode.pseudoCode}</p>
                                        <p className='mb-0'><strong>{t('ccOverrideText')} :</strong> {overrideCode.pseudoCodeText}</p>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                {!disabledSelect && (
                    <div className='text-center'>
                        <Button variant="primary" onClick={() => handleShowModal(true)}>{t('ccSelectConfiguration')}</Button>
                    </div>
                )}

                {pseudocodes.length > 0 && (

                    <PaginatedAccordion
                        pseudocodes={pseudocodes}
                        t={t}
                        hideSelectOrigin={hideSelectOrigin}
                        handleSetOrigin={handleSetOrigin}
                        handleSetDestination={handleSetDestination}
                    />

                   
                )}
            </div>
            <div className='text-end p-3'>
                {loadedItems > 20 && <Button variant='dark' className='scrollToTop__button' onClick={scrollToTop}> <FaArrowUp /></Button>}
            </div>
        </div>
    )
}